import { useRef } from 'react';

/* This hook could be useful when you need to perform calculations 
 based on the previous state without triggering additional renders */
export function usePrevCalculation<T>(factory: (prevResult: T) => T, initPrev: T): T {
  const prev = useRef<T>(initPrev);
  const result = factory(prev.current);
  prev.current = result;
  return result;
}
